/** Places a popover below (or above, if there's more room) its anchor, clamped inside the viewport. */
export function placePopover(anchor: DOMRect, pop: { width: number; height: number }, vw: number, vh: number, alignRight = false) {
  let left = alignRight ? anchor.right - pop.width : anchor.left;
  left = Math.min(Math.max(8, left), vw - pop.width - 8);
  const below = vh - anchor.bottom - 14;
  const above = anchor.top - 14;
  let top = anchor.bottom + 6;
  let maxHeight: number | undefined;
  if (pop.height > below && above > below) {
    top = Math.max(8, anchor.top - Math.min(pop.height, above) - 6);
    if (pop.height > above) maxHeight = above;
  } else if (pop.height > below) {
    maxHeight = below;
  }
  return { left, top, maxHeight };
}

export const isSmallScreen = (): boolean => typeof window !== 'undefined' && window.matchMedia('(max-width: 640px)').matches;
